export default (set, get, data) => set(
  () => ({
    bundles: {
      ...get().bundles,
      data
    }
  }),
  false,
  { type: 'design/updateBundles', data }
);
